/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import { ComponentRendererProps } from '../chakra/shared/Types';
import { useNext } from '../hooks/useNext';

function StartComponentRenderer({ controller, isCurrent }: ComponentRendererProps) {
  useNext({ controller, isCurrent, strategy: 'AUTO' });
  return null;
}

export default StartComponentRenderer;
